var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',{attrs:{"active":_vm.loader,"is-full-page":true,"background-color":"#074d3f","color":"#005a16 ","lock-scroll":true,"opacity":0.5,"height":128,"width":128},on:{"update:active":function($event){_vm.loader=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }